// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { ml, py, mx } from 'styled-components-spacing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fontLink, fontLinkActive, HeroNavBar } from '@styles/typography';
import theme from '@theme';

const { colors, borderRadius } = theme;

export const StyledWrapper = styled.div`
  ${fontLink}

  &.open {
    color: ${colors.defaultGreen};
  }

  position: relative;

  ${breakpoint('desktop')`
    font-size: 16px;
  `}

  ${breakpoint('largeDesktop')`
    font-size: 18px;
  `}
`;

export const StyledLabelsContainer = styled.div`
  display: flex;

  transition: all 0.5s ease;

  ${({ isActive }) => (isActive ? fontLinkActive : fontLink)}
  ${({ heroSection }) => (heroSection && HeroNavBar)}
  font-weight: ${({ isActive }) => (isActive ? 600 : 500)};

  cursor: pointer;

  & > * {
    pointer-events: none;
  }

  ${breakpoint('desktop')`
    font-size: 16px;
    ${mx(3)}
  `}

  ${breakpoint('largeDesktop')`
    font-size: 18px;
    ${mx(4)}
  `}
`;

export const StyledLabel = styled.span`
  white-space: nowrap;

  max-width: 310px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 3px;
`;

export const StyledIconsContainer = styled.div`
  width: 8px;
  height: 12px;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  ${ml(2)}
  color: inherit;
`;

export const StyledExpandedList = styled.div`
  min-width: 300px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 20;
  background-color: ${colors.white};
  ${py(3)}
  ${borderRadius.small}
  border: solid 1px ${colors.formSeparator};
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-top: none;
  -webkit-box-shadow: rgba(33, 40, 54, 0.2) 0px 5px 3px 0px;
// -webkit-box-shadow: 0 0 0 1px rgba(0,0,0,.15);

  transition: all 0.3s ease;

  &:not(.open) {
      visibility: hidden;
      opacity: 0;
  }
`;
